import decrypt from "../AESHashing/decrypt";

export default function decryptCartIds(encryptedCartIds: any) {
  const decryptedCartIds = JSON.parse(decrypt(encryptedCartIds));
  return decryptedCartIds;
}
